import { MountView } from "~/setup/view-mounter";

interface ComponentSetup {
    component: string;
    domId: string;
    props?: object;
}

const VIEW_SETUP_QUERY_SELECTOR = "[data-react-setup]";
const VIEW_DOM_SETUP_NAME_PREFIX = "GBK.views.";

function getDomViews(domSetups: Element[]) {
    return domSetups.reduce<MountView[]>((mountViews, setup) => {
        const parameters = parseDomViewSetup(setup);
        if (!parameters) {
            console.error("View Finder: Parse error for", setup);
            return mountViews;
        }

        const name = parameters.component.replace(VIEW_DOM_SETUP_NAME_PREFIX, "");
        const node = document.getElementById(parameters.domId);

        if (!node) {
            console.error(`View Finder: DOM element with id ${parameters.domId} was not found.`);
            return mountViews;
        }

        return [
            ...mountViews,
            {
                name,
                node,
                props: parameters.props
            }
        ];
    }, []);
}

function parseDomViewSetup(setup: Element): ComponentSetup | undefined {
    let parsed;

    try {
        parsed = JSON.parse(setup.innerHTML);
    } catch (e) {
        return;
    }

    return parsed;
}

export default function viewFinder(rootNode: HTMLElement = global.window.document.body): MountView[] {
    const domViews = getDomViews(Array.from(rootNode.querySelectorAll(VIEW_SETUP_QUERY_SELECTOR)));
    return domViews;
}
